import React from "react";
import { createRoot } from 'react-dom/client';
import Preisrechner from "./components/Preisrechner";


document.addEventListener("DOMContentLoaded", () => {
    const rootElement = document.getElementById('preisrechner');
    if(rootElement) {
        const root = createRoot(rootElement);
        const type = document.getElementById('type').value === '0'?'Privat':'Gewerbe';
        let energy;

        switch (document.getElementById('energieart').value) {
            case '0':
                energy = 'Strom'
                break;
            case '1':
                energy = 'Erdgas'
                break;
            case '2':
                energy = 'Heizstrom'
                break;
        }

        root.render(<Preisrechner type={type} energy={energy}/>);
    }
});
